// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 86 ? "7069e3e8" : chunkId) + "." + {"37":"0ebcdba19a46564b","86":"213378a31af9a40f","139":"e0b8da9815ba2cf2","296":"b929b53d8b9ce3ae"}[chunkId] + ".js";
};